import { forEach, filter, uniq, isEmpty } from 'lodash-es'
import T_SW from './viz-tsw.js'
const TSW = new T_SW()

function getAllresponses (answers, allResponses) {
  answers.forEach(function (ans) {
    if (ans.type === 'group') {
      getAllresponses(ans.children, allResponses)
    } else if (ans.type === 'answer') {
      allResponses.push(ans.content)
    }
  })
}

function generateTopBigrams (responses, termsCount) {
  var bigramsCount = {}

  responses.forEach(function (r) {
    // Clean and replace left/right single quote with straight single quote
    var words = TSW.clean(r).replace(/[\u2018\u2019]/g, "'").split(/\s/)
    var seenBigrams = {}

    words.forEach(function (w, index) {
      if (w.length < 2) return
      // Generate possible vigram
      var bigram = false
      if (index > 0 && words[index - 1].length > 1) bigram = words[index - 1] + ' ' + w
      // Check we have bigram and is not repeated
      if (!bigram || seenBigrams[bigram]) return
      seenBigrams[bigram] = true
      // Increment count
      if (bigram in bigramsCount) bigramsCount[bigram] += 1
      else bigramsCount[bigram] = 1
    })
  })

  Object.keys(bigramsCount).sort(function (a, b) {
    return bigramsCount[b] - bigramsCount[a]
  }).slice(0, 5).filter(function (x) {
    return bigramsCount[x] >= 5
  }).forEach(function (k) {
    termsCount[k] = bigramsCount[k]
  })
}

function generateTopUnigrams (responses, termsCount) {
  responses.forEach(function (r) {
    // Clean and replace left/right single quote with straight single quote
    var words = TSW.clean(r).replace(/[\u2018\u2019]/g, "'").split(/\s/)
    var seenWords = {}

    words.forEach(function (w, index) {
      if (w.length < 2) return
      // Generate the two possible vigram
      var bigram1 = false
      var bigram2 = false
      if (index > 0 && words[index - 1].length > 1) bigram1 = words[index - 1] + ' ' + w
      if (index < words.length - 1 && words[index + 1].length > 1) bigram2 = w + ' ' + words[index + 1]

      // Do not increment if the word belongs to a top bigram or is one character
      if ((bigram1 && termsCount[bigram1]) || (bigram2 && termsCount[bigram2]) || seenWords[w]) return
      seenWords[w] = true
      // Increment count for the word
      if (w in termsCount) termsCount[w] += 1
      else termsCount[w] = 1
    })
  })
}

// TODO: Cleanup, top terms are also generated in similar ways in
// - viz-format.js
// - viz-unit.js
// - text-response-helpers.js
export function getFrequencyWords (json) {
  var allResponses = []
  getAllresponses(json.answers, allResponses)

  var termsCount = { }
  // Update termsCount with the unigrams and bigrams
  generateTopBigrams(allResponses, termsCount)
  generateTopUnigrams(allResponses, termsCount)

  var words = Object.keys(termsCount).filter(word => {
    return !json.title.includes(word)
  })

  return words.sort(function (a, b) {
    return termsCount[b] - termsCount[a]
  }).filter(function (x) {
    return termsCount[x] >= 5
  }).slice(0, 10).map(function (x) {
    return { word: x, count: termsCount[x] }
  })
}

export function getResponseIDs (object) {
  const children = object.answers || object.children
  // If as deep as we can go grab rid
  if (!children) {
    return [object.rid]
  }
  // Else recursively dig in
  return children.reduce((acc, nestedObject) => {
    return acc.concat(getResponseIDs(nestedObject))
  }, [])
}

function flattenResponses (object) {
  const children = object.answers || object.children
  // If as deep as we can go grab rid
  if (!children) {
    return object
  }
  // Else recursively dig in
  return children.reduce((acc, nestedObject) => {
    return acc.concat(flattenResponses(nestedObject))
  }, [])
}

export function getResponseCount (respObject, total) {
  const responses = flattenResponses(respObject)
  return total ? responses.length : responses.filter(r => r.show).length
}

export function processTextJson (json) {
// only called if json does not have an answers property (aka legacy format for text responses)

  json.answers = []
  if (Object.keys(json.groups).length > 0) {
    forEach(json.groups, function (group, gKey) {
      var groupColl = { type: 'group', content: gKey.trim(), show: true, children: [] }
      forEach(group, function (bin, bKey) {
        var binColl = { type: 'group', content: bKey.trim(), show: true, children: [] }
        forEach(bin, function (ans, ansIdx) {
          var trimmedAnswer
          if (typeof ans === 'string') trimmedAnswer = ans.trim()
          else trimmedAnswer = ans.answer.trim()
          binColl.children.push({
            type: 'answer',
            id: ansIdx,
            content: trimmedAnswer.replace(/[\u2018\u2019]/g, "'"),
            show: true
          })
        })
        groupColl.children.push(binColl)
      })
      json.answers.push(groupColl)
    })
  } else if (Object.keys(json.bins).length > 0) {
    forEach(json.bins, function (bin, bKey) {
      var binColl = { type: 'group', content: bKey.trim(), show: true, children: [] }
      forEach(bin, function (ans, ansIdx) {
        var trimmedAnswer
        if (typeof ans === 'string') trimmedAnswer = ans.trim()
        else trimmedAnswer = ans.answer.trim()
        binColl.children.push({
          type: 'answer',
          id: ansIdx,
          content: trimmedAnswer.replace(/[\u2018\u2019]/g, "'"),
          show: true
        })
      })
      json.answers.push(binColl)
    })
  } else {
    forEach(json.tanswers, function (ans, ansIdx) {
      var trimmedAnswer
      if (typeof ans === 'string') trimmedAnswer = ans.trim()
      else trimmedAnswer = ans.answer.trim()
      json.answers.push({
        type: 'answer',
        id: ansIdx,
        content: trimmedAnswer.replace(/[\u2018\u2019]/g, "'"),
        show: true
      })
    })
  }
  if (json.groups) delete json.groups
  if (json.bins) delete json.bins
  if (json.tanswers) delete json.tanswers
  return json
}

function filterAnswers (answers, wordsList, logic) {
  if (answers.length === 0 || wordsList.length === 0) return answers

  if (answers[0].type === 'answer') {
    return filter(answers, function (obj) {
      var matches = []
      const regexMatch = new RegExp(wordsList.map(function (w) { return '\\b' + w + '(?![a-z\'`’])' }).join('|'), 'gi')
      matches = obj.content.replace(/[\u2018\u2019]/g, "'").match(regexMatch) || matches

      if (logic === 'AND' && uniq(matches).length === wordsList.length) return true
      if (logic === 'OR' && matches.length > 0) return true
      if (logic === 'NOT' && matches.length === 0) return true
      return false
    })
  } else {
    return forEach(answers, function (value, key, obj) {
      obj[key].children = filterAnswers(obj[key].children, wordsList, logic)
    })
  }
}

export function filterResponses (responses, wordsList, logic) {
  if (isEmpty(responses) || wordsList.length === 0) return responses.answers
  return filterAnswers(responses.answers, wordsList, logic)
}
